<template>
  <modal :modal-key="'paypal_confirm_purchase'" :class-style="'modal--welcomeback modal--zero-balance modal--purchase'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_confirm_purchase_successfull_purchase }}</h1>
      <img class="usericon" src="static/images/happy_face.svg" alt="">
    </template>
    <template slot="body">
      <p class="modal_strong">{{ getTranslations.home_modals_confirm_purchase_well_done }}</p>
      <p v-if="!getBundleData.joker">
        {{ getBundleData.numberOfGames?getBundleData.numberOfGames + ' ' +
        getTranslations.home_modals_confirm_purchase_successfull_games_were_unlocked : ''}}</p>
      <p v-if="!getBundleData.joker"> {{ getBundleData.numberOfGames &&
      getBundleData.points?getTranslations.home_modals_confirm_purchase_successfull_and :'' }}
        {{ getBundleData.points?getBundleData.points + ' ' +
          getTranslations.home_modals_confirm_purchase_successfull_points_were_added:''}}</p>
      <p>{{ getTranslations.home_modals_confirm_purchase_successfull_do_you_want_to_start_new_game }}</p>
    </template>
    <template slot="footer">
      <div @click.prevent="playMethod"><a
        class="btn2 btn2--std btn2--small btn2--fixed" style="cursor:pointer">{{getTranslations.home_modals_confirm_purchase_successfull_new_game
        }}</a></div>
    </template>
  </modal>
</template>

<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import ResumeGame from '@/components/home/modals/ResumeGame';
import ZeroBalance from '@/components/home/modals/ZeroBalance';
import ResubscribeGameSms from '@/components/home/modals/ResubscribeGameSms';
import ResubscribeGame from '@/components/home/modals/ResubscribeGame';
import PendingChallenge from '@/components/home/game/challenge/PendingChallenge';

export default {
  name: 'PaypalConfirmPurchase',
  components: {
    Modal,
  },
  methods: {
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapMutations('common', [
      'storeModalForStore',
    ]),
    playMethod() {
      console.log('showing resume game pop up in Store Page...');
      this.checkIfGameToResumeExists().then(() => {
        console.log('this.gameInProgress:', this.gameInProgress);
        if (this.gameInProgress) {
          console.log('showing resume game pop up...');
          this.storeModalForStore(ResumeGame);
        } else if (this.challengePending) {
          // a previous challenge still pending
          this.storeModalForStore(PendingChallenge);
        } else if (this.userDetails.availableGames === 0 && !this.userDetails.subscribed) {
          if (this.subAndUnsubViaSMS) {
            if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
              this.storeModalForStore(ResubscribeGameSms);
            } else {
              this.storeModalForStore(ResubscribeGame);
            }
          } else {
            this.storeModalForStore(ResubscribeGame);
          }
        } else if (this.userDetails.availableGames === 0 && this.userDetails.subscribed) {
          this.storeModalForStore(ZeroBalance);
        } else {
          this.$router.push('/searchingOpponent');
          this.storeModalForStore(null);
        }
      }).catch(error => console.error(error));
    },
  },
  computed: {
    ...mapState('common', [
      'modalForStore',
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
    ]),
    ...mapState('game', [
      'gameInProgress',
      'challengePending',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/paypal/PaypalConfirmPurchase.vue